// Shared by all environments.
export const OnboardingConfig = {
	qualificationCallUrl:
		'https://meetings.hubspot.com/thabisile-khumalo/clickguard-introduction-call',
	trafficAuditUrl: 'https://tools.clickguard.com',
	productTourUrl: 'https://share.layerpath.com/e/cmv15uovd0007jq04dm7gyye5/tour'
} as const
